import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';

export function getGroups(groupIds?: number[]): Action {
    return {type: ActionTypes.GET_GROUPS_REQUESTED, payload: groupIds};
}
